import Logo from "../../assets/img/logos/logoWhite.png";
import LogoColegio from "../../assets/img/logos/colegio.png";

const Footer = () => {
  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 py-8">
        {/* Main Content */}
        <div className="flex flex-col md:flex-row items-center justify-between">
          {/* Left Section - Logo */}
          <div className="mb-6 md:mb-0">
            <img
              src={Logo}
              alt="Inmobiliaria Claudia Saulo"
              className="h-16 mx-auto md:mx-0"
            />
          </div>

          {/* Center Section - Navigation */}
          <div className="mb-6 md:mb-0">
            <nav className="flex flex-col sm:flex-row gap-6 text-center">
              <a href="/" className="hover:text-[#4EB8A3] transition-colors">
                Inicio
              </a>
              <a
                href="/tipo/Venta"
                className="hover:text-[#4EB8A3] transition-colors"
              >
                Ventas
              </a>
              <a
                href="/tipo/Alquiler"
                className="hover:text-[#4EB8A3] transition-colors"
              >
                Alquileres
              </a>
              <a
                href="/sobreNosotros"
                className="hover:text-[#4EB8A3] transition-colors"
              >
                Nosotros
              </a>
            </nav>
          </div>

          {/* Right Section - Colegio Info */}
          <div className="flex flex-col items-center">
            <img
              src={LogoColegio}
              alt="Colegio Inmobiliario"
              className="h-12 mb-2"
            />
            <p className="text-xs text-center">
              Claudia Saulo Tº III - Fº 912 - Nº 1568
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 my-6"></div>

        {/* Copyright */}
        <div className="text-center text-sm">
          &copy; {new Date().getFullYear()} Inmobiliaria Claudia Saulo. Todos
          los derechos reservados.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
